import React, {useEffect} from 'react';
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool, faUserGraduate, faChalkboardTeacher, faNewspaper } from '@fortawesome/free-solid-svg-icons'

export default function Home() {

  useEffect(() => {
    document.title = "Cool Kids English - Parent Portal"
  }, []);

  return(
    <div>
      <h1>Home</h1>
      <p>Welcome to the Cool Kids English Parent Portal.</p>
      <p>Here you will find the latest news and updates about your child's Cool Kids English experience.</p>
      <div>
        <ul>
          <Nav.Item>
            <Nav.Link as={Link} to="/news"><FontAwesomeIcon icon={faNewspaper} /> Latest News</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/teachers"><FontAwesomeIcon icon={faChalkboardTeacher} /> Meet the Cool Kids English teachers</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/students"><FontAwesomeIcon icon={faUserGraduate} /> Students Classes Information</Nav.Link>
          </Nav.Item>
        </ul>
      </div>
    </div>
  )
}
